'use client'

import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

export type Tab = {
  name: string
  path: string
}

export const useMyPageTabs = () => {
  const pathname = usePathname()

  const tabs: Tab[] = useMemo(
    () => [
      { name: 'いいね・閲覧履歴', path: '/mypage/history' },
      { name: 'ご注文履歴', path: '/mypage/orders' },
      { name: '個人情報設定', path: '/mypage/profile' },
      { name: '住所登録・変更', path: '/mypage/address' },
      { name: '支払方法設定', path: '/mypage/payment' },
      { name: 'ログアウト', path: '/mypage/logout' },
    ],
    []
  )

  const subTabs: Record<string, Tab[]> = useMemo(
    () => ({
      '/mypage/history': [
        { name: 'いいねしたアイテム', path: '/mypage/like' },
        { name: '閲覧したアイテム', path: '/mypage/history' },
      ],
      '/mypage/profile': [
        { name: '個人情報', path: '/mypage/profile' },
        { name: 'メールアドレス変更', path: '/mypage/email' },
        { name: 'パスワード変更', path: '/mypage/password' },
        { name: '通知設定', path: '/mypage/notifications' },
        // TODO: CanadaGoose確認待ちのため一時的にコメントアウト (Allbirds先行リリース対応)
        // { name: 'ニュースレター設定', path: '/mypage/newsletter' },
      ],
    }),
    []
  )

  const activeTab = useMemo(() => {
    if (pathname === '/mypage/password') {
      return '/mypage/profile'
    }
    if (pathname === '/mypage/email') {
      return '/mypage/profile'
    }
    if (pathname === '/mypage/notifications') {
      return '/mypage/profile'
    }
    // TODO: CanadaGoose確認待ちのため一時的にコメントアウト (Allbirds先行リリース対応)
    // if (pathname === '/mypage/newsletter') {
    //   return '/mypage/profile'
    // }
    if (pathname === '/mypage/like') {
      return '/mypage/history'
    }
    return (
      tabs.find((tab) => pathname.startsWith(tab.path))?.path ?? tabs[1].path
    )
  }, [pathname, tabs])

  const activeSubTab = useMemo(() => {
    if (activeTab in subTabs) {
      return (
        subTabs[activeTab].find((subTab) => pathname === subTab.path)?.path ??
        subTabs[activeTab][0]?.path
      )
    }
    return null
  }, [activeTab, pathname, subTabs])

  return {
    tabs,
    activeTab,
    subTabs: subTabs[activeTab] || [],
    activeSubTab,
  }
}
